import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ProfileService } from '../../../pages/profile.service';

import { Menu } from './menu.model';
import { /*verticalMenuItems,*/ horizontalMenuItems } from './menu';

@Injectable()
export class MenuService {

  constructor(private location:Location,
              private router:Router,
              private profileService: ProfileService,){ } 
    
  public getVerticalMenuItems():Array<Menu> {

    var profile = this.profileService;
    var ggData = this.profileService.getLSGG();

    //console.log("init menu ggData", ggData);


    var verticalMenuItems = [ 
      new Menu (1, 'Dashboard', '/',  null,   'dashboard',           null, false, 0),
  
    ]
    /*
    verticalMenuItems.push(new Menu (10,'Unsecured',       null,   null, 'lock_open',     null, true, 0));
    
    verticalMenuItems.push(new Menu (11,'Debtors',         null,   null, 'perm_identity', null, true,  10));
    verticalMenuItems.push(new Menu (12,'HP1',        '/port-unsecured/unsec-hp1',             null, 'attach_money',       null, false, 11));
    verticalMenuItems.push(new Menu (13,'HP2',        '/port-unsecured/unsec-hp2',             null, 'attach_money',       null, false, 11));
    verticalMenuItems.push(new Menu (14,'HP2-1600',   '/port-unsecured/unsec-hp2-1600',        null, 'attach_money',       null, false, 11));
    verticalMenuItems.push(new Menu (15,'HP2-2400',   '/port-unsecured/unsec-hp2-2400',        null, 'attach_money',       null, false, 11));
    verticalMenuItems.push(new Menu (16,'CC-UPL1',    '/port-unsecured/unsec-cc-upl1',         null, 'credit_card',        null, false, 11));
    verticalMenuItems.push(new Menu (17,'HP3',        '/port-unsecured/unsec-hp3',             null, 'attach_money',       null, false, 11));
    verticalMenuItems.push(new Menu (18,'All',        '/port-unsecured/all-unsecured',         null, 'folder_shared',      null, false, 11));
    
    verticalMenuItems.push(new Menu (21,'OA',             null,   null,  'transfer_within_a_station',  null, true,  10));
    verticalMenuItems.push(new Menu (22,'HP1',         '/port-unsecured/oa-hp1/HP1',           null, 'attach_money',       null, false, 21));
    verticalMenuItems.push(new Menu (23,'HP2',         '/port-unsecured/oa-hp2/HP2',           null, 'attach_money',       null, false, 21));
    verticalMenuItems.push(new Menu (24,'HP2-1600',    '/port-unsecured/oa-hp2-1600/HP2-1600', null,'attach_money',        null, false, 21));
    verticalMenuItems.push(new Menu (25,'HP2-2400',    '/port-unsecured/oa-hp2-2400/HP2-2400', null,'attach_money',        null, false, 21));
    verticalMenuItems.push(new Menu (26,'CC-UPL1',     '/port-unsecured/oa-cc-upl1/CC-UPL1',   null,'credit_card',         null, false, 21));
    verticalMenuItems.push(new Menu (27,'HP3',         '/port-unsecured/oa-hp3/HP3',           null, 'attach_money',       null, false, 21));
    
    verticalMenuItems.push(new Menu (31,'Reports',     '/port-unsecured/dtunsec-reports',  null, 'receipt',       null, false, 10));
    verticalMenuItems.push(new Menu (32,'Fix data',      '/port-unsecured/dtunsec-import',   null, 'build',       null, false, 10));
    
    verticalMenuItems.push(new Menu (40, 'Housing',        null,   null,   'home',         null, true, 0)); 
    verticalMenuItems.push(new Menu (41, 'SCB-HS1',     '/port-secured/sec-scb-hs1',       null, 'home',           null, false, 40)); 
    verticalMenuItems.push(new Menu (42, 'SCB-HS2',     '/port-secured/sec-scb-hs2',       null, 'home',           null, false, 40));
    
    verticalMenuItems.push(new Menu (50, 'Corporate',      null,   null,   'business',     null, true, 0)); 
    verticalMenuItems.push(new Menu (51, 'SCBT-CORP1',  '/port-secured/sec-scbt-corp1',    null, 'business',       null, false, 50)); 
    verticalMenuItems.push(new Menu (52, 'SCBT-CORP2',  '/port-secured/sec-scbt-corp2',    null, 'business',       null, false, 50));
    verticalMenuItems.push(new Menu (53, 'SAM-CORP1',   '/port-secured/sec-sam-corp1',     null, 'business',       null, false, 50)); 
    verticalMenuItems.push(new Menu (54, 'SCBT-CORP3',  '/port-secured/sec-scbt-corp3',    null, 'business',       null, false, 50)); 
    verticalMenuItems.push(new Menu (55, 'TMB-CORP1',   '/port-secured/sec-tmb-corp1',     null, 'business',       null, false, 50)); 
    verticalMenuItems.push(new Menu (56, 'ICBC-CORP1',  '/port-secured/sec-icbc-corp1',    null, 'business',       null, false, 50));
    verticalMenuItems.push(new Menu (57, 'All',         '/port-secured/all-secured',       null, 'folder_shared',  null, false, 50));  
    
    verticalMenuItems.push(new Menu (60,'IBIZ',            null,   null,  'money',  null, true,  0));
    verticalMenuItems.push(new Menu (61,'Import',       '/ibiz/ibiz-import',        null, 'cloud_upload',           null, false, 60));
    verticalMenuItems.push(new Menu (62,'2561',         '/ibiz/ibiz-list-1/2018',   null, 'format_list_bulleted',   null, false, 60));
    verticalMenuItems.push(new Menu (63,'2562',         '/ibiz/ibiz-list-2/2019',   null, 'format_list_bulleted',   null, false, 60));
    verticalMenuItems.push(new Menu (64,'Reports',      '/ibiz/ibiz-reports',       null, 'receipt',                null, false, 60));
    verticalMenuItems.push(new Menu (65,'Fix',          '/ibiz/ibiz-fix',           null, 'build',                  null, false, 60));
    
    verticalMenuItems.push(new Menu (70,'Investment',      null,   null,  'assessment',  null, true,  0));
    verticalMenuItems.push(new Menu (71,'Portfolios',   '/investment/inv-ports',    null, 'folder_shared',          null, false, 70));
    verticalMenuItems.push(new Menu (72,'KCC ID',       '/investment/inv-kccid',    null, 'perm_identity',          null, false, 70));
    verticalMenuItems.push(new Menu (73,'Reports',      '/investment/inv-reports',  null, 'receipt',                null, false, 70));
    verticalMenuItems.push(new Menu (74,'Fix',          '/investment/inv-fix',      null, 'build',                  null, false, 70));
    
    console.log("genisADM",ggData["isADM"]);
    if(ggData["isADM"]){
      console.log("in 1");
    }
    if(ggData["isADM"] == true){
      console.log("in 2");
    }
    if(ggData["isADM"] == false){
      console.log("in 3");
    }
    if( ggData["isADM"] ){
      verticalMenuItems.push(new Menu (90, 'Usersss', '/users', null, 'supervisor_account', null, false, 0));
    }
  */
    return verticalMenuItems;
  }

  public getHorizontalMenuItems():Array<Menu> {

    var profile = this.profileService;
    var ggData = this.profileService.getLSGG();

    // var horizontalMenuItems = [ 
    //   new Menu (1, 'Dashboard', '/',  null,   'dashboard', null, false, 0),
  
    // ]


    return horizontalMenuItems;
  }

  public expandActiveSubMenu(menu:Array<Menu>){
      let url = this.location.path();
      let routerLink = url; // url.substring(1, url.length);
      let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
      if(activeMenuItem[0]){
        let menuItem = activeMenuItem[0];
        while (menuItem.parentId != 0){  
          let parentMenuItem = menu.filter(item => item.id == menuItem.parentId)[0];
          menuItem = parentMenuItem;
          this.toggleMenuItem(menuItem.id);
        }
      }
  }

  public toggleMenuItem(menuId){
    let menuItem = document.getElementById('menu-item-'+menuId);
    let subMenu = document.getElementById('sub-menu-'+menuId);  
    if(subMenu){
      if(subMenu.classList.contains('show')){
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      }
      else{
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }      
    }
  }

  public closeOtherSubMenus(menu:Array<Menu>, menuId){
    let currentMenuItem = menu.filter(item => item.id == menuId)[0]; 
    if(currentMenuItem.parentId == 0 && !currentMenuItem.target){
      menu.forEach(item => {
        if(item.id != menuId){
          let subMenu = document.getElementById('sub-menu-'+item.id);
          let menuItem = document.getElementById('menu-item-'+item.id);
          if(subMenu){
            if(subMenu.classList.contains('show')){
              subMenu.classList.remove('show');
              menuItem.classList.remove('expanded');
            }              
          } 
        }
      });
    }
  }
  

}
